<template>
    <table class="table bg-white table-bordered">
        <tbody>
            <tr>
                <td>
                    <span>{{ 'Method' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.response.method }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'All' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.all }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Blue' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.blue }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Green' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.green }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Red' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.red }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Percentage Difference' | trans }}</span>
                </td>
                <td>
                    <span>{{ percentDiff }}%</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { translate } from '../../../../helper/translate';
export default {
    name: 'ImageQualityFactorTable',
    props: {
        factors: Object,
        response: Object,
        percentDiff: String,
    },
    filters: {
        trans(msg) {
            return translate(msg);
        },
    },
};
</script>
<style></style>
